<template>
  <div class="footer">
    <div>
      <div class="footerWrapper">
        <img class="logo" :src="branding.logo_url" alt="logo" />
        <div class="links">
          <div class="legal">
            <a href="https://lunchbox.io/terms" target="_blank">
              <p>Terms Of Use</p>
            </a>
            <a href="https://lunchbox.io/privacy" target="_blank">
              <p>Privacy</p>
            </a>
          </div>
          <div class="social">
            <a v-for="link in branding.links" :key="link" :href="link.url" target="_blank">
              <p>{{ link.name }}</p>
            </a>
          </div>
          <div v-if="appStoreLinksExist" class="apps">
            <img
              v-if="this.branding.app_store_links.app_store_url?.length > 0"
              @click="openAppPage('ios')"
              src="@/assets/icons/appStore.png"
              alt="App Store"
            />
            <img
              v-if="this.branding.app_store_links.google_play_store_url?.length > 0"
              @click="openAppPage('android')"
              src="@/assets/icons/googlePlay.png"
              alt="Google Play Store"
            />
          </div>
        </div>
      </div>
      <div v-if="branding.display_options?.menu_disclaimer?.enable" class="menuDisclaimer" v-html="getPurifiedBody"></div>
    </div>
    <a v-if="!branding.display_options?.hide_powered_by_lunchbox_logo" class="poweredBy" href="https://www.lunchbox.io" target="_blank">
      <img src="@/assets/icons/poweredBy.svg" alt="Powered By Lunchbox" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DOMPurify from 'dompurify'

export default {
  computed: {
    ...mapState(['branding']),
    appStoreLinksExist() {
      return (
        this.branding?.app_store_links?.app_store_url?.length > 0 ||
        this.branding?.app_store_links?.google_play_store_url?.length > 0
      )
    },
    getPurifiedBody() {
      // only allow br, strong, and a tags
      const allowedTags = ['br', 'strong', 'a', 'p']
      const allowedAttributes = ['href', 'target']
      const purifiedBody = DOMPurify.sanitize(this.branding.display_options.menu_disclaimer.text, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes,
      })
      return purifiedBody
    },
  },
  methods: {
    openAppPage(store) {
      const url =
        store === 'ios'
          ? this.branding.app_store_links.app_store_url
          : this.branding.app_store_links.google_play_store_url
      window.open(url, '_blank')
    },
  },
}
</script>

<style src="../../../assets/css/Main/Layout/FooterView.css" scoped></style>
